export const additionalInformationLabels = {
  countryRisk: 'Country risk',
  businessRisk: 'Business risk',
};
